// TODO: Export / target SV 2
import CommentaryWidget from './CommentaryWidget.vue';

import CommentaryWidget2 from './CommentaryWidget2.vue';

const CommentaryWidgetSV1 = CommentaryWidget;
const CommentaryWidgetSV2 = CommentaryWidget2;

export default CommentaryWidgetSV1;

export { CommentaryWidgetSV1, CommentaryWidgetSV2 };
